import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import axios from 'axios'

import {LunaModal} from '../widgets/lunamodal.component'

import PlannerContainer from '../planner/planner.container'
import {ItineraryTitle} from './itinerarytitle.component'
import {TripTitle} from './triptitle.component'
import {ItineraryTitleButtons} from './itinerarytitlebuttons.component'
// import {SaveIcon} from '../widgets/saveicon.component'

export class ItineraryTop extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        let halfHiddenClass = classNames({
            'collapsed': this.props.halfHidden
        }) 


        let homeLink = this.props.isLunaTrip ? '/' : '/trips'

        return (
            <div id="itinerary-top" className={halfHiddenClass}>
                <div className="container-fluid">
                    <div id="itinerary-top-band" className="row">
                        <div className="itinerary-top-title">
                            <div className="trip-titles">
                                <TripTitle
                  tripName={ this.props.tripName }
                  onUpdateTripTitle={ this.props.onUpdateTripTitle }/>
                                {/* <ItineraryTitle
                  itinName={ this.props.itinName }
                  onUpdateItinName={ this.props.onUpdateItinName }
                />*/}
                            </div>
                        </div>
                        <a className="logo" href={homeLink}>
                            <img src="/assets/img/logos/luna_beta.svg"/>
                        </a>
                        <ItineraryTitleButtons {...this.props}/>
                    </div>
                </div>
                <PlannerContainer/>
            </div>
        )
    }
}